import $ from "jquery";
import debug from 'bows/dist/bows.min.js';
const log = debug("Test Lab Pagination");

let currentPage = 1;
let totalPages = 0;
let pagination_links = '';
let pagination_prev = '';
let pagination_next = '';

let toShow = 20;


const $testLab = $('#test-lab')

let testLabAccordion = '';
let testLabList = '';
let listLength = 0;

const arrowButton = `<svg width="30px" height="16px" viewBox="0 0 30 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-275.000000, -705.000000)">
            <g transform="translate(54.000000, 678.000000)" >
                <g transform="translate(221.000000, 27.000000)">
                    <polygon class="fill" fill-rule="nonzero" points="22.4419479 15.1560431 29.5999982 7.95604348 22.4419479 0.756043911 21.0592539 2.14874456 25.8530279 6.97064208 13.9566417 6.97064208 13.8881593 6.97064208 11.9999993 6.97064208 11.9999993 8.94144488 13.8881593 8.94144488 13.9566417 8.94144488 25.8530279 8.94144488 21.0592539 13.7633424"></polygon>
                    <rect class="fill" fill-rule="nonzero" x="7.99999952" y="7.15604353" width="1.5999999" height="1.5999999"></rect>
                    <rect class="fill" fill-rule="nonzero" x="0" y="7.15604353" width="1.5999999" height="1.5999999"></rect>
                    <rect class="fill" fill-rule="nonzero" x="3.99999976" y="7.15604353" width="1.5999999" height="1.5999999"></rect>
                </g>
            </g>
        </g>
    </g>
</svg>
`;



function updatePagination() {
	if (currentPage === 1) {
		pagination_prev.attr('aria-hidden', 'true').prop('disabled', true);
	} else {
		pagination_prev.removeAttr('aria-hidden').prop('disabled', false);
	}

	if (currentPage === totalPages) {
		pagination_next.attr('aria-hidden', 'true').prop('disabled', true);
	} else {
		pagination_next.removeAttr('aria-hidden').prop('disabled', false);
	}

	pagination_links.removeClass('current');
	pagination_links.eq(currentPage - 1).addClass('current');
}


function showItems() {
	hideCompanies();
	updatePagination();
	let start = ((currentPage - 1) * toShow);
	let end = ((currentPage - 1) * toShow) + toShow;


	if (currentPage === 1) {
		start = 0;
		end = toShow;
	}
	// log('showItems');

	for (let i = start; i < end; i++) {
		testLabList.eq(i).removeClass('lab--pagination-no-show');

	}
}

function hideCompanies() {
	testLabList.addClass('lab--pagination-no-show');
}


function changeThePage() {
	currentPage = parseInt(this.dataset.page);
	showItems();
}

function previousPage() {
	if (currentPage !== 1) {
		currentPage -= 1;
		showItems();
	}
}

function nextPage() {
	if (currentPage !== totalPages) {
		currentPage += 1;
		showItems();
	}
}

function addPaginationAction() {
	pagination_links = $testLab.find('.pagination__link');
	pagination_prev = $testLab.find('.pagination__prev');
	pagination_next = $testLab.find('.pagination__next');

	pagination_links.on('click', changeThePage);
	pagination_prev.on('click', previousPage);
	pagination_next.on('click', nextPage);

	// log('addPaginationAction');
	showItems();
}



export function setVars() {

	testLabList = $testLab.find('.js-wikit-accordion__item:not(.lab--no-filtered)');
	listLength = testLabList.length;
	log(listLength);
}

export function showPagination() {
	// log('showPagination')
	currentPage = 1;
	totalPages = Math.ceil(listLength / toShow);

	$testLab.find('.pagination').remove();


	let pagination = `
	<div class="pagination" aria-label="Test Lab Pagination">
		<button type="button" class="pagination__prev" aria-hidden="true" disabled>
			<span class="pagination__svg" aria-hidden="true">${arrowButton}</span>
			<span class="pagination__text">Previous</span>
		</button>
		<ul class="pagination__list">`;

	for (let i = 0; i < totalPages; i++) {
		let className = 'pagination__link ';
		if (i === 0) {
			className += ' current';
		}
		pagination += `<li class="pagination__item"><button type="button" class="${className}" data-page="${i + 1}">${i + 1}</button></li>`;
	}

	pagination += `
		</ul >
		<button type="button" class="pagination__next">
			<span class="pagination__text">Next</span>
			<span class="pagination__svg" aria-hidden="true">${arrowButton}</span>
		</button>
	</div > `;

	if (totalPages > 1) {
		$testLab.append(pagination);
	}

	addPaginationAction();
}

export default {
	showPagination,
	setVars
}
